import {StyleSheet} from "aphrodite";

import {semanticColor} from "@khanacademy/wonder-blocks-tokens";

export default StyleSheet.create({
    redText: {
        color: semanticColor.core.foreground.critical.subtle,
    },
});
